export function demoSources(gifUrl) {
  const gif = gifUrl || null;
  const match = typeof gif === 'string' && gif.match(/^(https:\/\/[a-z0-9-]+\.supabase\.co\/storage\/v1\/object\/public\/exercises\/)([^\s/?#\\]+)\.gif$/);
  if (!match || match[0] !== gif) return { gif, video: null, poster: null };
  return { gif, video: `${match[1]}video/${match[2]}.mp4`, poster: `${match[1]}video/${match[2]}.jpg` };
}
